<template>
    <div class="accordion custom-accordion">
        <div class="accordion-item custom-accordion__item">
            <h2 class="accordion-header custom-accordion__header" :id="`filter-accordion-${filterKey}-label`">
                <button
                    :aria-controls="`filter-accordion-${filterKey}`"
                    aria-expanded="false" class="accordion-button custom-accordion__button collapsed"
                    :data-bs-target="`#filter-accordion-${filterKey}`"
                    data-bs-toggle="collapse"
                    type="button">{{label}}</button>
            </h2>
            <div :aria-labelledby="`filter-accordion-${filterKey}-label`" class="accordion-collapse collapse custom-accordion__collapse" :id="`filter-accordion-${filterKey}`">
                <div class="accordion-body custom-accordion__body">
                    <form class="form select-item-form">
                        <div class="form-check form-check-inline select-item-form__form-check" v-for="item in items">
                            <input
                                class=" form-check-input select-item-form__form-check-input"
                                :id="`${filterKey}${item.id}`"
                                type="checkbox"
                                :value="item.id"
                                :checked="isChecked(item)"
                                @click="handleClick(item)"
                            >
                            <label class="form-check-label select-item-form__form-check-label" :for="`${filterKey}${item.id}`">
                                {{getLabel(item)}}
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SidebarFilter",
    props: {
        items: {type: Array, required: true},
        label: {type: String, required: true},
        filterKey: {type: String, required: true},
    },
    computed: {
        request() {
            return this.$store.state.archive.request;
        }
    },
    methods: {
        getLabel(item) {
            if (this.filterKey === 'brand') {
                return item.name;
            } else {
                return item.value;
            }
        },
        isChecked(item) {
            if (this.filterKey === 'brand') {
                return this.request.brands.indexOf(item.id) > -1;
            } else {
                return this.request.attributes.indexOf(item.id) > -1;
            }
        },
        handleClick(item) {
            if (this.isChecked(item)) {
                if (this.filterKey === 'brand') {
                    this.$store.commit('archive/removeBrand', item.id);
                } else {
                    this.$store.commit('archive/removeAttribute', item.id);
                }
            } else {
                if (this.filterKey === 'brand') {
                    this.$store.commit('archive/addBrand', item.id);
                } else {
                    this.$store.commit('archive/addAttribute', item.id);
                }
            }
            this.$store.commit('archive/fireTrigger');
            this.$store.commit('archive/setPage', 1);
        },
    }
}
</script>

<style scoped>

</style>
